const RELEASE_API_BASE_URL =
  process.env.REACT_APP_RELEASE_MANAGER_API_URL || '/release-manager-api'

export type PullRequestInput = {
  url: string
}

export type ReleaseRequest = {
  date: string
  increment: number | null
  requestedBy: string
  pullRequests: PullRequestInput[]
}

export type ResolvedPullRequest = {
  repository: string
  number: number
  title: string
  sourceBranch: string
  headSha: string
  state: string
  merged: boolean
  url: string
}

export type ValidationIssue = {
  level: 'error' | 'warning'
  code: string
  message: string
  repository?: string
}

export type ReleasePreview = {
  branchName: string
  date: string
  increment: number
  canCreate: boolean
  pullRequests: ResolvedPullRequest[]
  issues: ValidationIssue[]
}

export type BranchCreationResult = {
  repository: string
  pullRequestNumber: number
  branchName: string
  headSha: string
  status: 'created' | 'unchanged' | 'conflict' | 'failed'
  message: string
  branchUrl?: string
}

export type ReleaseResult = {
  branchName: string
  requestedBy: string
  createdAt: string
  results: BranchCreationResult[]
}

async function request<T>(path: string, body: ReleaseRequest): Promise<T> {
  const response = await fetch(`${RELEASE_API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const payload = await response.json().catch(() => null)

  if (!response.ok) {
    const message =
      payload?.issues
        ?.map((issue: ValidationIssue) => issue.message)
        .join(' ') ||
      payload?.detail ||
      `Release Manager request failed (${response.status})`
    throw new Error(message)
  }

  return payload as T
}

export function previewRelease(
  release: ReleaseRequest,
): Promise<ReleasePreview> {
  return request<ReleasePreview>('/api/releases/preview', release)
}

export function createRelease(
  release: ReleaseRequest,
): Promise<ReleaseResult> {
  return request<ReleaseResult>('/api/releases', release)
}
